import {Setting} from "./Setting";

export const populationSetting: Setting = {
    key: "Population",
    title: "Население",
    description: "Население описывает демографию, численность, распределение и характеристики жителей мира. Это не только придает миру реалистичности, но и влияет на сюжет, экономику, общественные структуры, культуру и взаимодействие персонажей.",
    components:[
        {
            title: "Численность населения",
            subComponents: [
                {
                    title: "Мегаполисы",
                    description: `Миллионы жителей, развитая инфраструктура.`,
                    examples: ["Мегаполис Элладор, где живут все расы."]
                },
                {
                    title: "Города",
                    description: `Десятки или сотни тысяч человек.`,
                    examples: ["Столица Королевства, где сосредоточена власть."]
                },
                {
                    title: "Деревни и поселения",
                    description: `Сотни или тысячи жителей.`,
                    examples: ["Деревня Лесной Ручей, где живут эльфы."]
                },
                {
                    title: "Изолированные группы",
                    description: `Маленькие колонии, кланы, племена.`,
                    examples: ["Племя Кровавого Копья, живущее в джунглях."]
                }]
        },
        {
            title: "Распределение населения",
            subComponents: [
                {
                    title: "Централизованное",
                    description: `Большая часть людей живет в крупных городах.`,
                    examples: ["Город-государство, где сосредоточена вся власть."]
                },
                {
                    title: "Равномерное",
                    description: `Население распределено по всей территории.`,
                    examples: ["Деревни и города, равномерно разбросанные по континенту."]
                },
                {
                    title: "Разобщенное",
                    description: `Множество изолированных поселений.`,
                    examples: ["Группы выживших, разбросанные по пустошам."]
                },
                {
                    title: "Кластеры",
                    description: `Группы городов, соединенные общей культурой или экономикой.`,
                    examples: ["Города-государства, объединенные торговыми связями."]
                }]
        },
        {
            title: "Состав населения",
            subComponents: [
                {
                    title: "Этническое разнообразие",
                    description: `Различные расы, культуры, подрасы (люди, эльфы, орки, мутанты).`,
                    examples: ["Город, где живут все расы, объединенные общими интересами."]
                },
                {
                    title: "Демографическое распределение",
                    description: `Возрастные группы: дети, взрослые, старики. Гендерное распределение: равномерное или с перекосом.`,
                    examples: ["Город, где дети решают судьбу взрослых."]
                },
                {
                    title: "Магические или технологические изменения",
                    description: `Люди с киберимплантами, магические существа, мутанты.`,
                    examples: ["Город, где все жители обладают магическими способностями."]
                }]
        },
        {
            title: "Повседневная жизнь населения",
            subComponents: [
                {
                    title: "Занятость",
                    description: `Фермеры, ремесленники, солдаты, ученые, маги.`,
                    examples: ["Город, где все жители занимаются одним делом."]
                },
                {
                    title: "Досуг",
                    description: `Театры, таверны, арены, магические турниры.`,
                    examples: ["Город, где каждый день проходят фестивали и праздники."]
                }]
        },
        {
            title: "Динамика населения",
            subComponents: [
                {
                    title: "Рост населения",
                    description: `Экономический или магический бум. Высокий уровень медицины или магического лечения.`,
                    examples: ["Город, где все жители живут вечно."]
                },
                {
                    title: "Снижение численности",
                    description: `Войны, эпидемии, природные катаклизмы.`,
                    examples: ["Город, где все жители умирают от неизлечимой болезни."]
                }]
        }
    ],
    prompt: {
        component: {
            list: "Создай и опиши компоненты сеттинга Населения для игры.",
            single: "Создай сеттинг Населения для игры",
            extend: "Дополни деталями описание компонента Население и разбей на абзацы."
        },
        element: {
            list: "Создай и опиши элементы сеттинга Населения для игры.",
            single: "Создай сеттинг Населения для игры",
            extend: "Дополни деталями описание элементпа Население и разбей на абзацы."
        },
        lore: {
            list: "Создай элементы лора на основе этого элемента населения. Его историю, мифы, влияние на мир и персонажей",
            single: "Создай элементы лора на основе этого элемента населения. Опиши что-то одно, например: историю, мифы, влияние на мир и персонажей",
            extend: "Дополни описание элемента лора населения и разбей на абзацы."
        }
    }
}